import"./index-8p04sssx.mjs";
import {
  createColorMatrixImplementations
} from "./index-cdp7tr8x.mjs";
import {
  DEFAULT_HUE_DEGREES,
  hueDegreesSchema,
  assertOptionalFiniteNumber
} from "./index-wxhvgv2s.mjs";
import {
  assertEffectParamsObject
} from "./index-4fvp93ps.mjs";

// src/hue.ts
import { Internals } from "remotion";
var { createEffect } = Internals;
var hueSchema = {
  degrees: hueDegreesSchema
};
var resolve = (p) => ({
  degrees: p.degrees ?? DEFAULT_HUE_DEGREES
});
var validateHueParams = (params) => {
  assertEffectParamsObject(params, "Hue");
  assertOptionalFiniteNumber(params.degrees, "degrees");
};
var hue = createEffect({
  type: "dev.remotion.effects.hue",
  label: "hue()",
  documentationLink: "https://www.remotion.dev/docs/effects/hue",
  calculateKey: (params) => {
    const r = resolve(params);
    return `hue-${r.degrees}`;
  },
  implementations: {
    ...createColorMatrixImplementations("hue", (params) => {
      const { degrees } = resolve(params);
      const radians = degrees % 360 * Math.PI / 180;
      const cosine = Math.cos(radians);
      const sine = Math.sin(radians);
      return new Float32Array([
        0.213 + 0.787 * cosine - 0.213 * sine,
        0.715 - 0.715 * cosine - 0.715 * sine,
        0.072 - 0.072 * cosine + 0.928 * sine,
        0,
        0.213 - 0.213 * cosine + 0.143 * sine,
        0.715 + 0.285 * cosine + 0.14 * sine,
        0.072 - 0.072 * cosine - 0.283 * sine,
        0,
        0.213 - 0.213 * cosine - 0.787 * sine,
        0.715 - 0.715 * cosine + 0.715 * sine,
        0.072 + 0.928 * cosine + 0.072 * sine,
        0,
        0,
        0,
        degrees % 360 === 0 ? 1 : 0,
        0
      ]);
    }),
    "2d": Internals.createEffectImplementation({
      setup: () => null,
      apply: ({ source, target, width, height, params }) => {
        const ctx = target.getContext("2d");
        if (!ctx) {
          throw new Error("Failed to acquire 2D context for hue effect. The canvas may have been assigned a different context type.");
        }
        const r = resolve(params);
        ctx.clearRect(0, 0, width, height);
        ctx.filter = `hue-rotate(${r.degrees}deg)`;
        ctx.drawImage(source, 0, 0, width, height);
        ctx.filter = "none";
      },
      cleanup: () => {
        return;
      }
    })
  },
  schema: hueSchema,
  validateParams: validateHueParams
});
export {
  hue
};
